import { Component, OnInit } from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AccountRecoveryModel} from '../../../models/requests/account/account-recovery.model';
import {RecoveryPasswordModel} from '../../../models/requests/account/recovery-password.model';
import {ApiService} from '../../../services/api.service';
import {SweetalertService} from '../../../services/sweetalert.service';
import {ErrorService} from '../../../services/error.service';

@Component({
  selector: 'app-change-password-by-recovery',
  templateUrl: './change-password-by-recovery.component.html',
  styleUrls: ['./change-password-by-recovery.component.scss']
})
export class ChangePasswordByRecoveryComponent implements OnInit {

  private routeSub: Subscription;
  public isWaiting = false;
  public hash;

  public recoveryPasswordForm: FormGroup = this.formBuilder.group({
    password: [null, Validators.required],
    repeatPassword: [null, Validators.required]
  });

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private router: Router,
    private sweetalertService: SweetalertService,
    private errorService: ErrorService
  ) { }

  ngOnInit(): void {
    this.routeSub = this.route.params.subscribe(params => {
      this.hash = params.hash;
    });
  }

  public onFormSubmit(recoveryPasswordForm) {
    const recoveryPasswordModel: RecoveryPasswordModel = recoveryPasswordForm.value;
    recoveryPasswordModel.hash = this.hash;

    this.isWaiting = true;

    if (!recoveryPasswordForm.valid) {
      this.isWaiting = false;
      const password = recoveryPasswordForm.controls.password.errors;
      const repeatPassword = recoveryPasswordForm.controls.repeatPassword.errors;
      if (password) {
        if (password.required) {
          this.sweetalertService.formError('Pole z hasłem nie może być puste');
          return;
        }
        if (password.minlength) {
          this.sweetalertService.formError('Hasło musi posiadać minimum 8 znaków');
          return;
        }
      }
      if (repeatPassword) {
        if (repeatPassword.required) {
          this.sweetalertService.formError('Pole z powtórzonym hasłem nie może być puste');
          return;
        }
      }
    }

    if (recoveryPasswordModel.password !== recoveryPasswordModel.repeatPassword) {
      this.isWaiting = false;
      this.sweetalertService.formError('Podane hasła nie zgadzają się');
      return;
    }

    this.apiService.changePasswordByRecovery(recoveryPasswordModel).subscribe((response: any) => {
      this.isWaiting = false;
      this.sweetalertService.recoveryPasswordSuccess();
      this.router.navigate(['']);
    }, error => {
      this.isWaiting = false;
      this.errorService.handleError(error);
    });
  }

}
